import { useEffect, useState } from 'react'

const ITEMS: [string, string, string][] = [
  ['#/', '🎯', 'Today'],
  ['#/bonus', '⚡', 'Bonus'],
  ['#/stats', '📊', 'Stats'],
  ['#/archive', '🗓️', 'History'],
  ['#/account', '👤', 'Profile'],
]

/** Mobile-only sticky bottom navigation (hidden ≥768px and during gameplay). */
export function BottomNav() {
  const [hash, setHash] = useState(location.hash || '#/')
  useEffect(() => { const f = () => setHash(location.hash || '#/'); addEventListener('hashchange', f); return () => removeEventListener('hashchange', f) }, [])
  return (
    <>
      <div className="navspace" aria-hidden />
      <nav className="bottomnav" aria-label="main navigation">
        {ITEMS.map(([href, emoji, label]) => (
          <a key={href} href={href} className={hash === href || (href !== '#/' && hash.startsWith(href)) ? 'on' : ''}>
            <span className="i">{emoji}</span><span className="l">{label}</span>
          </a>
        ))}
      </nav>
    </>
  )
}
